// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../configs/Config.mjs";

function devLog(key, value) {
  if (Config$PorterinUtils.env === "development") {
    console.log("===============" + key + ":", value);
    return ;
  }
  
}

export {
  devLog ,
}
/* Config-PorterinUtils Not a pure module */
